import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, map, take, tap } from 'rxjs';
import { InitFacade } from 'src/app/store/facade/init.facade';
import { ExpensesFacade } from '../store/facade/expenses.facade';

export const expensesGuard: CanActivateFn = () => {
  const facade = inject(ExpensesFacade);
  const initFacade = inject(InitFacade);

  return initFacade.userId$.pipe(
    filter((userId): userId is number => !!userId),
    take(1),
    tap(() => facade.getExpenses()),
    map(() => true),
  );
};
